
import { Injectable, Signal, computed, inject, signal } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { debounceTime } from 'rxjs';

import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { ScreenSizeInfo } from './screensize.service.classes';


@Injectable({
    providedIn: 'root'
})
export class ScreenSizeService {
    // Injected Services
    private breakpointObserver = inject(BreakpointObserver);

    // Create a map to display breakpoint names.
    public displayNameMap = new Map([
        [Breakpoints.XSmall, 'XSmall'],
        [Breakpoints.Small, 'Small'],
        [Breakpoints.Medium, 'Medium'],
        [Breakpoints.Large, 'Large'],
        [Breakpoints.XLarge, 'XLarge'],
    ]);

    // Transform Breakpoint Observeable into Signal
    private media = toSignal( 
        this.breakpointObserver.observe([
            Breakpoints.XSmall,
            Breakpoints.Small,
            Breakpoints.Medium,
            Breakpoints.Large,
            Breakpoints.XLarge,
        ])
        // .pipe(debounceTime(250))
    );

    private currentScreenSize = computed(() => {
        const breakpoints = this.media()?.breakpoints;
        let screenSize = '';
        if (breakpoints) {
            for (const query of Object.keys(breakpoints)) {
                if (breakpoints[query]) {
                    screenSize = (this.displayNameMap.get(query) ?? 'Unknown');
                    break;
                }
            }
        }
        return screenSize;
    });

    CurrentScreenSize = computed(() => this.currentScreenSize());
    IsXSmall = computed(() => this.media()?.breakpoints[Breakpoints.XSmall]);
    IsSmall = computed(() => this.media()?.breakpoints[Breakpoints.Small]);
    IsMedium = computed(() => this.media()?.breakpoints[Breakpoints.Medium]);
    IsLarge = computed(() => this.media()?.breakpoints[Breakpoints.Large]);
    IsXLarge = computed(() => this.media()?.breakpoints[Breakpoints.XLarge]);
    IsSmallDisplay = computed(() => this.media()?.breakpoints[Breakpoints.XSmall] || this.media()?.breakpoints[Breakpoints.Small]);
    IsUpToMediumDisplay = computed(() => this.media()?.breakpoints[Breakpoints.XSmall] || this.media()?.breakpoints[Breakpoints.Small] || this.media()?.breakpoints[Breakpoints.Medium]);
    MediaMatches = computed(() => this.media()?.breakpoints[Breakpoints.XSmall] 
                            || this.media()?.breakpoints[Breakpoints.Small] 
                            || this.media()?.breakpoints[Breakpoints.Medium] 
                            // || this.media()?.breakpoints[Breakpoints.Large]
    );

    // ScreenSize: Signal<ScreenSizeInfo> = computed(() => {
    //     const size = this.currentScreenSize();
    //     return {
    //         Alias: size === 'XSmall' ? 'xs' : 
    //                size === 'Small' ? 'sm' : 
    //                size === 'Medium' ? 'md' : 
    //                size === 'Large' ? 'lg' : 
    //                'xl',
    //         CurrentScreenSize: size,
    //         IsSmallDisplay: size === 'XSmall' || size === 'Small',
    //         IsXs: size === 'XSmall',
    //         IsSm: size === 'Small',
    //         IsMd: size === 'Medium',
    //         IsLg: size === 'Large',
    //         IsXl: size === 'XLarge',
    //         MediaMatches: this.breakpointObserver.isMatched('(max-width: 599px)')
    //     }
    // });

    // IsSmallDisplay = computed(() => this.ScreenSize().IsSmallDisplay);

    // private currentScreenSize = signal<string>('XSmall');

    // constructor() {
    //     this.breakpointObserver.observe([
    //         Breakpoints.XSmall,
    //         Breakpoints.Small,
    //         Breakpoints.Medium,
    //         Breakpoints.Large,
    //         Breakpoints.XLarge,
    //     ])
    //     .pipe(takeUntilDestroyed(), debounceTime(250))
    //     .subscribe(result => {
    //         for (const query of Object.keys(result.breakpoints)) {
    //             if (result.breakpoints[query]) {
    //                 this.currentScreenSize.set(this.displayNameMap.get(query) ?? 'Unknown');
    //             }
    //         }
    //     });
    // }
}
